import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import ServiceDomainEditor from './EditorPages/ServiceDomainEditor';
import ServiceDomainResults from './ResultsPages/ServiceDomainResults';

function ServiceDomains({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <ServiceDomainEditor id={queryParams['id']} /> :
            <ServiceDomainResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(ServiceDomains);